import polyfillObjectFit from 'object-fit-images';
export default function app(hydrateApp) {
    function startApp() {
        polyfillObjectFit();
        if (window.ha.polyfilled === true) {
            hydrateApp();
        } else {
            window.ha = window.ha || {};
            window.ha.main = hydrateApp;
        }
    }

    const readyState = document.readyState;
    if (readyState === 'interactive' || readyState === 'complete') {
        startApp();
    } else {
        document.addEventListener('DOMContentLoaded', startApp);
    }
}
